import { render, staticRenderFns } from "./paymentDialogSet.vue?vue&type=template&id=0187f4d3&scoped=true"
import script from "./paymentDialogSet.vue?vue&type=script&lang=ts"
export * from "./paymentDialogSet.vue?vue&type=script&lang=ts"
import style0 from "./paymentDialogSet.vue?vue&type=style&index=0&id=0187f4d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0187f4d3",
  null
  
)

export default component.exports